<script setup lang="ts">
import EmptySvg from '@/svg/empty.svg'

interface IEmptyDatasetProps {
  title: string
  subtitle?: string
  image?: string
}
const props = defineProps<IEmptyDatasetProps>()
</script>

<template>
  <div class="empty-dataset">
    <EmptySvg />
    <p class="title">{{ props.title }}</p>
    <p class="subtitle">{{ props.subtitle }}</p>
    <slot></slot>
  </div>
</template>

<style lang="scss">
.empty-dataset {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;

  .title {
    font-weight: 500;
    margin: 0.4em;
  }

  .subtitle {
    font-weight: 300;
    font-size: 0.9em;
    margin-bottom: 1.6em;
    color: #d1d1d1;
  }

  button {
    border: 1px solid white;
  }
}
</style>
